import React from 'react'
import { lightTheme } from '@/customTheme'
import ContextMenuItem from './ContextMenuItem'
import ContextMenuContainer from './ContextMenuContainer'
import { StyleObject } from 'styletron-react'

export type ContextMenuPanelAction = {
  id: string
  title: string
  icon: React.FC<{ fill?: string }>
  enhancer?: string
  disabled?: boolean
  onClick: () => void
}

type ContextMenuPanelProps = {
  items: ContextMenuPanelAction[]
  style?: StyleObject
  fireCanvasEvent?: boolean
}

function ContextMenuPanel({ items, style, fireCanvasEvent = false }: ContextMenuPanelProps) {
  return (
    <ContextMenuContainer
      id="context-menu-panel"
      style={{
        width: 'auto',
        minWidth: '255px',
        maxWidth: '270px',
        gap: '4px',
        ...style,
      }}
    >
      {items.map((action) => {
        const Icon = action.icon
        return (
          <ContextMenuItem
            key={action.id}
            startEnhancer={<Icon fill={action.disabled ? lightTheme.colors.grayScale200 : lightTheme.colors.blackGray} />}
            content={action.title}
            endEnhancer={action.enhancer || undefined}
            handleClick={(e) => {
              e?.stopPropagation()
              action.onClick()
            }}
            disabled={action.disabled}
            fireCanvasEvent={fireCanvasEvent}
          />
        )
      })}
    </ContextMenuContainer>
  )
}

export default ContextMenuPanel
